import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { FulfillmentGateway } from './fulfillment.gateway'
import { FulfillmentSubmitOrder } from '../models/fulfillment-submit-order'
import { FulfillmentDataResponse } from '../models/fulfillment-data-response'
import { FulfillmentOrderDetailModel } from '../models/fulfillment-order-details'
import { UserProfileBasic } from '../../user-management/models/user-profile-basic'
import { FulfillmentOrderDetailAll } from '../models/fulfillment-order-detail-all'
import { FulfillmentAppFeatureSetting } from '../models/fulfillment-app-feature-setting'
import { FulfillmentCriteria } from '../models/fulfillment-criteria'
import { StringWrapper } from '../models/string-wrapper'
import { FulfillmentSubmitOrderResponse } from '../models/fulfillment-submit-order-response'

@Injectable()
export class NetworkFulfillmentGateway extends FulfillmentGateway {
    constructor(private http: HttpClient) {
        super()
    }

    submitOrder(fulfillmentSubmitOrder: FulfillmentSubmitOrder): Observable<FulfillmentSubmitOrderResponse> {
        return this.http.post<FulfillmentSubmitOrderResponse>('../api/submitKitOrder', JSON.stringify(fulfillmentSubmitOrder))
    }

    getFulfillmentOrderDetail(agentID: string, eventID: number): Observable<FulfillmentOrderDetailAll> {
        return this.http.get<FulfillmentOrderDetailAll>(`../api/getFulfillmentOrderDetail/${agentID}/${eventID}`)
    }

    getFulfillmentOrderDetails(agentID: string, orgID: number, planYear: number): Observable<FulfillmentOrderDetailModel[]> {
        return this.http.get<FulfillmentOrderDetailModel[]>(`../api/getFulfillmentOrderDetails/${agentID}/${orgID}/${planYear}`)
    }

    getUserProfile(userProfileName: string): Observable<string> {
        let stringWrapper: StringWrapper = {} as StringWrapper
        stringWrapper.childString = userProfileName
        return this.http.post<string>(`../api/getUserProfileForUserProfileName`, stringWrapper)
    }

    changeOrderStatus(eventID: number, status: string, loginID: string): Observable<string> {
        return this.http.get<string>(`../api/changeOrderStatus/${eventID}/${status}/${loginID}`)
    }

    getFulfillmentAppFeatureSettings(featureID: number, orgID: number): Observable<FulfillmentAppFeatureSetting[]> {
        return this.http.get<FulfillmentAppFeatureSetting[]>(`../api/getFulfillmentAppFeatureSettings/${featureID}`)
    }

    getOrderHistory(fulfillmentCriteria: FulfillmentCriteria) {
        return this.http.post<FulfillmentOrderDetailModel[]>(`../api/getOrderHistory`, JSON.stringify(fulfillmentCriteria))
    }

    getOrderHistorySync(fulfilmentCriteria: FulfillmentCriteria): FulfillmentOrderDetailModel[] {
        var data = JSON.stringify(fulfilmentCriteria)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', `../api/getOrderHistory`, false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getEnrollmentEffectiveDateByOrgID(orgID: number, PlanYear: string): Observable<string> {
        return this.http.get<string>(`../api/getEnrollmentEffectiveDateByOrgID/${orgID}/${PlanYear}`)
    }
}
